import Axios from 'axios';

const getDefaultState = () => {
  return {
    dummies: [],
    dummiesLoading: false,
    dummiesLoaded: false
  };
};

const state = getDefaultState();

const getters = {
  getInternships: state => {
    return state.dummies.filter(x => x.process == 'mars-miep');
  },

  getLeaderships: state => {
    return state.dummies.filter(x => x.process == 'mars-mlep');
  }
};

const mutations = {
  SET_DUMMIES: (state, payload) => {
    state.dummies = payload;
  },

  SET_DUMMIES_LOADING: (state, payload) => {
    state.dummiesLoading = payload;
  },

  SET_DUMMIES_LOADED: (state, payload) => {
    state.dummiesLoaded = payload;
  },

  REMOVE_DUMMY: (state, dummyId) => {
    const index = state.dummies.findIndex(x => x.id == dummyId);

    if (index !== -1) {
      state.dummies.splice(index, 1);
    }
  },

  RESET_STATE_INDEX: state => {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  async fetchDummies({ commit }, process) {
    commit('SET_DUMMIES_LOADED', false);
    commit('SET_DUMMIES_LOADING', true);

    await Axios.get(`/1.0/spec-private/mars/status-message?process=${process}`)
      .then(response => {
        commit('SET_DUMMIES', response.data.data);
        commit('SET_DUMMIES_LOADED', true);
      })
      .finally(() => {
        commit('SET_DUMMIES_LOADING', false);
      });
  },

  async addDummy({ commit, dispatch }, payload) {
    commit('SET_DUMMIES_LOADING', true);

    // const params = {
    //   status_id: Number(payload.status_id),
    //   message: payload.message,
    //   process: payload.process // код процесса mars-mlep или mars-miep
    // };

    await Axios.post('/1.0/spec-private/mars/status-message', payload)
      .then(() => {
        dispatch('fetchDummies', payload.process);
      })
      .finally(() => {
        commit('SET_DUMMIES_LOADING', false);
      });
  },

  async updateDummy({ commit, dispatch }, payload) {
    commit('SET_DUMMIES_LOADING', true);

    await Axios.put(`/1.0/spec-private/mars/status-message/${payload.id}`, payload)
      .then(() => {
        dispatch('fetchDummies', payload.process);
      })
      .finally(() => {
        commit('SET_DUMMIES_LOADING', false);
      });
  },

  async deleteDummy({ commit }, itemId) {
    await Axios.delete(`/1.0/spec-private/mars/status-message/${itemId}`).then(() => {
      commit('REMOVE_DUMMY', itemId);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
